import { useMemo } from 'react';
import { useSearchParams } from 'react-router';
import { type SortDirection } from '@optimization/ssi-common';

const useSortDirection = (): SortDirection => {
  const [searchParameters] = useSearchParams();
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- fallback to 'asc' if param is empty string
  return useMemo(() => (searchParameters.get('sortDir') || 'asc') as SortDirection, [searchParameters]);
};

export default useSortDirection;
